var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1080PBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1155,
    height: 234,
    viewBox: "0 0 1155 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_1232",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1155,
    height: 234
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1155,
    height: 234,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_1232)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.891 134.168C588.891 139.719 590.533 145.145 593.609 149.766C596.686 154.386 601.06 157.993 606.181 160.134C611.302 162.275 616.942 162.854 622.392 161.798C627.841 160.742 632.857 158.098 636.808 154.2C640.758 150.301 643.468 145.321 644.596 139.886C645.724 134.451 645.22 128.803 643.147 123.654C641.074 118.505 637.525 114.084 632.946 110.946C628.367 107.809 622.963 106.095 617.412 106.021C613.685 105.972 609.984 106.663 606.526 108.055C603.068 109.447 599.92 111.513 597.267 114.131C594.613 116.75 592.506 119.87 591.068 123.309C589.631 126.749 588.89 130.44 588.891 134.168Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.48954 215.466C0.490032 221.017 2.13176 226.443 5.20827 231.064C8.28479 235.684 12.6587 239.291 17.78 241.432C22.9013 243.573 28.5413 244.152 33.9907 243.096C39.4401 242.04 44.4556 239.396 48.4065 235.497C52.3574 231.598 55.0673 226.618 56.1953 221.183C57.3234 215.748 56.8193 210.101 54.7464 204.952C52.6734 199.803 49.1243 195.382 44.5452 192.244C39.9662 189.107 34.5617 187.393 29.0114 187.319C25.2837 187.27 21.5832 187.961 18.1249 189.353C14.6666 190.745 11.5193 192.811 8.86572 195.429C6.21219 198.048 4.1053 201.168 2.66739 204.607C1.22948 208.047 0.489208 211.738 0.48954 215.466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.229 140.285H390.873V177.814H203.229V140.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1061.66 0H1249.3V37.5288H1061.66V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.186 160.05L742.44 163.615L770.399 179.94L839.077 112.763C839.531 112.328 840.136 112.084 840.766 112.084C841.395 112.084 842 112.328 842.454 112.763L910.006 179.752L938.153 163.615C940.081 162.538 941.903 161.281 943.594 159.862L868.537 86.118C861.027 78.7377 850.919 74.6023 840.39 74.6023C829.861 74.6023 819.753 78.7377 812.244 86.118L737.186 160.05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.63 247.626L415.884 251.192L443.843 267.517L512.52 200.34C512.974 199.904 513.58 199.661 514.209 199.661C514.839 199.661 515.444 199.904 515.898 200.34L583.45 267.329L611.596 251.192C613.524 250.115 615.346 248.858 617.038 247.439L541.98 173.695C534.471 166.314 524.363 162.179 513.834 162.179C503.305 162.179 493.197 166.314 485.687 173.695L410.63 247.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.9 226.351V329.504C1263.91 340.139 1261.13 350.591 1255.82 359.805C1250.5 369.019 1242.86 376.671 1233.65 381.988L1144.26 433.565C1135.06 438.875 1124.63 441.671 1114.01 441.671C1103.39 441.671 1092.96 438.875 1083.76 433.565L994.369 381.988C985.159 376.671 977.513 369.019 972.202 359.805C966.891 350.591 964.103 340.139 964.119 329.504V226.351C964.13 215.742 966.93 205.321 972.24 196.136C977.549 186.951 985.181 179.323 994.369 174.018L1083.76 122.442C1092.96 117.132 1103.39 114.336 1114.01 114.336C1124.63 114.336 1135.06 117.132 1144.26 122.442L1233.65 174.775C1242.73 180.015 1250.29 187.523 1255.59 196.565C1260.89 205.606 1263.76 215.87 1263.9 226.351Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1080PBgImg);
export default __webpack_public_path__ + "static/media/1080p-bg-img.5ea2a2f1b5e6342f57dc9fc8cfc64b76.svg";
export { ForwardRef as ReactComponent };